import {loadElementLazyImage} from './lazy-load'
import LocomotiveScroll from 'locomotive-scroll'
import { breakpointUp } from './breakpoints'
import { setUrlHash } from './navigation'

let locoScrollPopup = null

export function initializePopups(locoScroll){


  $('.js-open-popup').click(function(){
    let popupId = $(this).data('popup')
    let videoUrl = $(this).data('url')
    let type = $(this).data('type')
    openPopup(popupId, locoScroll, videoUrl, type)
  })


  $('.js-close-popup').click(function(){
    let popup = $(this).closest('.js-popup')
    closePopup(popup, locoScroll)
  })


  $('.popup').click(function(e){
    let target = $(e.target)
    if (target.hasClass('popup-flex')) {
      let popup = target.closest('.js-popup')
      if (!popup.hasClass('js-cookies-popup'))
        closePopup(target.closest('.js-popup'), locoScroll)
    }
  })

  $(document).keyup(function(e) {
    if (e.key === "Escape") { // escape key maps to keycode `27`
      closePopup($('.js-popup'), locoScroll)
    }
  });



}


export function closePopup(popup, locoScroll){
  popup.fadeOut(400, function(){
    // popup.find('video').each(function(){
    //   this.pause()
    // })
    popup.find('iframe').attr('src', '').css('display', 'none')
    popup.find('video source').attr('src', '').css('display', 'none')
  })
  $('html').removeClass('modal-open')

  if (locoScrollPopup){
    locoScrollPopup.destroy()
    $('html').addClass('has-scroll-smooth')
    locoScroll.start()
  }

  setUrlHash($('.js-go-to.js-active').data('go-to'))
}


export function openPopup(popupId, locoScroll, videoUrl, type){
  let popup = $('.js-popup[data-popup="'+popupId+'"]')
  if (popup.length) {
    loadElementLazyImage(popup.find('.lazy'))
    popup.fadeIn()
    $('html').addClass('modal-open')

    if (videoUrl !== undefined){
      if (type === 'iframe'){
        console.log(videoUrl)
        popup.find('iframe').attr('src', videoUrl).css('display', 'block')
      } else {
        popup.find('video source').atrr('src', videoUrl).css('display', 'block')
      }
    }

    if (popup.hasClass('js-locomotive-popup')) {
      if (breakpointUp('lg')) {
        locoScroll.stop()
        locoScrollPopup = new LocomotiveScroll({
          el: popup[0],
          smooth: true,
          reloadOnContextChange: true
        })
      }

    }

    if (popupId !== 'cookies') {
      setUrlHash('popup-'+popupId)
    }
  }
}




